import AllResourcesSwitch from './AllResourcesSwitch';

export default AllResourcesSwitch;
